import React, { Component } from 'react';

import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Dropzone from 'react-dropzone';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
import * as Transfer from './Saga/Transfer';
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ApplicationList from "./ApplicationList";
// import { Field} from 'redux-form';

import './Css/Transfer.css';
import { withStyles } from '@material-ui/core/styles';
var moment = require("moment-timezone");
const styles = (theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});
const { CSVLink } = require('react-csv');
// import DatePicker from "react-datepicker";
const headers = [
  { label: "登録日時", key: "created_at" },
  { label: "状態", key: "kakumei_status_result" },
　{ label: "サイト", key: "site_name" },
  { label: "建物名", key: "tatemono_name" },
  { label: "部屋名", key: "room_name" },
  { label: "顧客名", key: "rent_customer_name" },
  { label: "契約日", key: "contract_date" },
  { label: "店舗名", key: "section_name" },
  { label: "銀行番号", key: "bank_code" },
  { label: "銀行名", key: "bank_name" },
  { label: "支店コード", key: "shop_code" },
  { label: "支店名", key: "shop_name" },
  { label: "口座種別", key: "deposit_kind_name" },
  { label: "口座番号", key: "account_number" },
  { label: "口座名義", key: "account_name_katakana" },
  { label: "消込日時", key: "deleted_at" },
  { label: "革命登録日時", key: "kakumei_updated_at" },
  { label: "引き落とし開始月", key: "billing_start_month" },

];
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {

  rent_transfer_accounts: any,
  delete_rent_transfer_accounts: any,
  change_transfer_modal: any,
  update_rent_transfer_accounts: any,
  rent_transfer_accounts_search: any,
  change_rent_transfer_accounts_search: any,
  get_rent_transfer_accounts: any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string,
  // update_kyousai_comp: any,
  // upload_kyousai_csv: any,
  classes: any,
  transfer_loading: boolean,
  // change_search_list: any,
  // search_list: any,
  // get_kyousais: any,
  // matching: any,
  // delete_kyousais: any,
  // all_select: any,
  // kyousais: any,
  // get_kyousais_csv: any,
}


interface State {
  refresh: boolean

}


class KyousaiSearch extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      refresh: false
    }
    // this.onDrop = this.onDrop.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeChecked = this.onChangeChecked.bind(this);
    this.onChangeContractStartDate = this.onChangeContractStartDate.bind(this);
    this.onChangeContractEndDate = this.onChangeContractEndDate.bind(this);
    this.onChangeInputStartDate = this.onChangeInputStartDate.bind(this);
    this.onChangeInputEndDate = this.onChangeInputEndDate.bind(this);

    // this.handle_change_search_completed = this.handle_change_search_completed.bind(this);

  }
  // onDrop = (files: any) => {
  //   console.log(files)
  //   const file = files[0]
  //   const reader = new FileReader()
  //   reader.readAsDataURL(file)
  //   reader.onload = () => {
  //     // this.setState({
  //     //   base64: reader.result,
  //     //   name: file.name,

  //     // })
  //   }

  //   let sendfile: any = [];
  //   sendfile.window = window;
  //   sendfile.file = files;
  //   // sendfile.id=this.props.introduction_file_id;
  //   this.props.upload_kyousai_csv(sendfile)


  //   // this.props.add_introduction_file(sendfile)
  // };


  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }

  onChange(e: any) {

    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search[e.target.name] = e.target.value
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
  }


  onChangeStartDate(e: any) {
    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.shori_start_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }
  onChangeEndDate(e: any) {

    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.shori_end_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }

  onChangeChecked(e: any) {

    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.checked = !rent_transfer_accounts_search.checked;
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }




  onChangeContractStartDate(e: any) {
    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.contract_start_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }
  onChangeContractEndDate(e: any) {

    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.contract_end_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }



  onChangeInputStartDate(e: any) {
    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.input_start_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }
  onChangeInputEndDate(e: any) {

    let rent_transfer_accounts_search = this.props.rent_transfer_accounts_search
    rent_transfer_accounts_search.input_end_date = moment(e).format("YYYY/MM/DD");
    // this.props.search_list
    this.props.change_rent_transfer_accounts_search(rent_transfer_accounts_search)
    this.setState({ refresh: !this.state.refresh })
  }
  onClickRe(e:any){
    this.props.change_transfer_modal(true)
  }
  // handle_change_search_completed(e: any) {

  //   let search_list = this.props.search_list
  //   search_list.search_completed = e.target.checked
  //   if (e.target.checked) {
  //     let dt = new Date();
  //     let month = dt.getMonth() + 1;
  //     //1ヶ月前
  //     let lastMonth = dt.setMonth(month - 2);
  //     search_list.start_date = lastMonth
  //     search_list.end_date = null
  //   } else {
  //     search_list.start_date = null
  //     search_list.end_date = null
  //   }
  //   this.props.change_search_list(search_list)
  //   this.setState({ refresh: !this.state.refresh })

  // }

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div>
        {/* <form onSubmit={handleSubmit}  > */}
        <table>

          <tbody>

            <tr >

              <td >
                <TextField
                  name="name"
                  label="お客様名"
                  onChange={this.onChange}
                  //   component="input"
                  type="text"
                  defaultValue={this.props.rent_transfer_accounts_search.name}
                  //placeholder=""
                  className="form-control"
                />
              </td>

              <td >
                <TextField
                  name="tatemono_name"
                  label="物件名"
                  onChange={this.onChange}
                  //   component="input"
                  type="text"
                  defaultValue={this.props.rent_transfer_accounts_search.tatemono_name}
                  //placeholder=""
                  className="form-control"
                />
              </td>


            </tr>




            <tr >

              <td colSpan={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="反映/消込日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // defaultValue={this.props.rent_transfer_accounts_search.shori_start_date}
                    onChange={this.onChangeStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.props.rent_transfer_accounts_search.shori_start_date}
                    //    onChange={this.handleContractionDateChangeStart}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  //   minDateMessage="契約日を選択してください"
                  // minDate={new Date("2000-01-01")}
                  // invalidDateMessage={"日付の形式が違います"}
                  />
                  ～
                  <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="反映/消込日"
                    style={{ marginLeft: "20px" }}
                    // value={this.props.search_list.end_date}
                    onChange={this.onChangeEndDate}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="end_date"
                    value={this.props.rent_transfer_accounts_search.shori_end_date}
                    //  value={this.props.estimate_search.contractDateEnd}
                    // //  value={this.props.estimateData.applicationDate}
                    //  onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  // invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>




                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.rent_transfer_accounts_search.checked}
                      onChange={this.onChangeChecked}
                      name="search_completed"
                      color="primary"

                    />
                  }
                  label="チェック済"
                  style={{ marginTop: "20px", marginLeft: "60px" }}
                />

              </td>

            </tr >





            <tr >

              <td colSpan={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // defaultValue={this.props.rent_transfer_accounts_search.shori_start_date}
                    onChange={this.onChangeContractStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.props.rent_transfer_accounts_search.contract_start_date}
                    //    onChange={this.handleContractionDateChangeStart}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  //   minDateMessage="契約日を選択してください"
                  // minDate={new Date("2000-01-01")}
                  // invalidDateMessage={"日付の形式が違います"}
                  />
                  ～
                  <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "20px" }}
                    autoOk={true}
                    // value={this.props.search_list.end_date}
                    onChange={this.onChangeContractEndDate}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="end_date"
                    value={this.props.rent_transfer_accounts_search.contract_end_date}
                    //  value={this.props.estimate_search.contractDateEnd}
                    // //  value={this.props.estimateData.applicationDate}
                    //  onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  // invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>
              </td>


              <td colSpan={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="登録日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    // defaultValue={this.props.rent_transfer_accounts_search.shori_start_date}
                    onChange={this.onChangeInputStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.props.rent_transfer_accounts_search.input_start_date}
                    //    onChange={this.handleContractionDateChangeStart}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  //   minDateMessage="契約日を選択してください"
                  // minDate={new Date("2000-01-01")}
                  // invalidDateMessage={"日付の形式が違います"}
                  />
                  ～
                  <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="登録日"
                    style={{ marginLeft: "20px" }}
                    autoOk={true}
                    // value={this.props.search_list.end_date}
                    onChange={this.onChangeInputEndDate}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="end_date"
                    value={this.props.rent_transfer_accounts_search.input_end_date}
                    //  value={this.props.estimate_search.contractDateEnd}
                    // //  value={this.props.estimateData.applicationDate}
                    //  onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  // invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>
              </td>
              <td>
                {/* <button
                  // onClick={this.props.all_select}
                  type="button"
                  style={{ marginTop: "5px" }}
                  className="btn btn-sm btn-success float-left"
                >全選択・解除</button> */}

                <button
                  type="button"
                  style={{ margin: "5px" }}
                  className="btn btn-primary float-left"
                  onClick={()=>this.props.change_transfer_modal(true)}
                >取り込み</button>

                <button
                  type="button"
                  style={{ margin: "5px" }}
                  className="btn btn-danger float-left"
                  onClick={this.props.update_rent_transfer_accounts}
                >登録</button>

                <button
                  type="submit"
                  style={{ margin: "5px" }}
                  className="btn btn-success float-right"
                  onClick={this.props.get_rent_transfer_accounts}
                >検索</button>

              </td>
              <td>



                <button
                  onClick={this.props.delete_rent_transfer_accounts}
                  style={{ margin: "5px" }}
                  className="btn btn-danger float-right"
                >消込</button>

                <CSVLink className="btn btn-primary float-right"
                  filename={"WEB口座振替チェックリスト.csv"}
                  style={{ margin: "5px" }} headers={headers} data={this.props.rent_transfer_accounts} >
                  CSV
                </CSVLink>
                {/* <button
                  // onClick={this.props.get_kyousais_csv}
                  style={{ margin: "5px" }}
                  className="btn btn-success float-right"
                >CSV</button> */}

                <span style={{ margin: "10px" }}>{this.props.rent_transfer_accounts.length}件</span>
              </td>

            </tr >
          </tbody>
        </table>


        <ApplicationList/>


        {/* </form> */}



        <Backdrop className={this.props.classes.backdrop} open={this.props.transfer_loading}>
          <CircularProgress color="inherit" />
        </Backdrop>

      </div>
    );
  }
}




const mapStateToProps = (state: any) => {
  return {

    // responseid: state.customersReducer.responseid,
    // responsedetail: state.customersReducer.responsedetail,
    // customerNewDisp: state.customersReducer.customerNewDisp,
    // csv_loading: state.kyousaiReducer.csv_loading,
    // search_list: state.kyousaiReducer.search_list,
    // kyousais: state.kyousaiReducer.kyousais,
    rent_transfer_accounts: state.Transfer.rent_transfer_accounts,
    transfer_loading: state.Transfer.transfer_loading,
    rent_transfer_accounts_search: state.Transfer.rent_transfer_accounts_search,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    delete_rent_transfer_accounts(state: any) {
      dispatch(Transfer.delete_rent_transfer_accounts(state))
    },
    update_rent_transfer_accounts(state: any) {
      dispatch(Transfer.update_rent_transfer_accounts(state))
    },
    change_rent_transfer_accounts_search(state: any) {
      dispatch(Transfer.change_rent_transfer_accounts_search(state))
    },
    get_rent_transfer_accounts(state: any) {
      dispatch(Transfer.get_rent_transfer_accounts(state))
    },
    change_transfer_modal(state: any) {
      dispatch(Transfer.change_transfer_modal(state))
    },
    // matching(state: any) {
    //   dispatch(Transfer.matching(state))
    // },
    // delete_kyousais(state: any) {
    //   dispatch(Transfer.delete_kyousais(state))
    // },
    // all_select(state: any) {
    //   dispatch(Transfer.all_select(state))
    // },
    // get_kyousais_csv(state: any) {
    //   dispatch(Transfer.get_kyousais_csv(state))
    // },
  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(KyousaiSearch));

// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);
// export default  reduxForm<Props>({
//     form: 'formset',

// })(AccountingListSearchComponent);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(KyousaiSearch)

// export default Form;

